import { z } from "zod/mini"

export const IntegrationFieldContentType = "IntegrationFieldsContent" as const

export const IntegrationFieldContentSchema = z.object({
	__TYPE__: z.literal(IntegrationFieldContentType),
	value: z.string(),
})

export type IntegrationFieldContent = z.infer<typeof IntegrationFieldContentSchema>
